/* eslint-disable @typescript-eslint/camelcase */
import { Grid, makeStyles } from '@material-ui/core';
import Button from 'components/Button';
import { Formik } from 'formik';
import i18n from 'i18n';
import React from 'react';
import GenericForm from 'skyone-lib/lib/GenericForm';
import styles from '../Template/styles';
import screenFields from './formFields';
import { initialValues } from './initialValues';
import validationSchema from './schema';

const useStyles = makeStyles(styles);

export interface Props {
  defaultValues?: typeof initialValues;
  isLoading?: boolean;
  onSubmit: (values: typeof initialValues) => void;
  onCancel: () => void;
}

export default function FormUser({
  defaultValues,
  isLoading,
  onSubmit,
  onCancel,
}: Props) {
  const classes = useStyles();

  const isEdit = !!defaultValues;

  return (
    <React.Fragment>
      <Grid
        item
        container
        className={classes.container}
        data-testid={'autosky-formgroup'}
      >
        <Formik
          initialValues={defaultValues || initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          enableReinitialize
        >
          {({ setFieldValue, submitForm, errors, values }) => (
            <Grid container spacing={2}>
              <GenericForm
                overrideClasses={{
                  selectLabel: { fontSize: 12, fontWeight: 500 },
                }}
                fields={values}
                screenFields={screenFields.slice(0, isEdit ? 2 : 3)}
                setFieldValue={setFieldValue}
                errors={errors}
              />
              {isEdit && (
                <Grid container item xs={12} spacing={0}>
                  <GenericForm
                    fields={values}
                    screenFields={screenFields.slice(3, 5)}
                    setFieldValue={setFieldValue}
                    errors={errors}
                  />
                </Grid>
              )}

              <Grid
                container
                justify="flex-end"
                className={classes.buttonsBase}
              >
                <Grid container className={classes.buttonsAlign}>
                  <Button
                    id="submit-button"
                    onClick={submitForm}
                    isLoading={isLoading}
                    submitButton
                  >
                    {i18n.t(isEdit ? 'SAVE_KEY' : 'REGISTER_KEY')}
                  </Button>
                  <Button
                    id="cancel-button"
                    variant="outlined"
                    onClick={onCancel}
                  >
                    {i18n.t('CANCEL_KEY')}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Formik>
      </Grid>
    </React.Fragment>
  );
}
